import {
  APIError,
  ERROR_MESSAGES_MAP,
  ErrorType,
  HTTP_STATUS_CODE_MAP,
  InternalErrorMessage,
} from './types';

const getErrorMessageByHTTPStatusCode = (
  statusCode: number,
): Partial<ErrorType> => HTTP_STATUS_CODE_MAP[statusCode] || 'NETWORK_ERROR';

const getErrorMessageIfApiError = (
  error: APIError,
): Partial<ErrorType> | undefined => {
  if (error.status !== undefined) {
    return getErrorMessageByHTTPStatusCode(error.status);
  }
  return undefined;
};

export const getInternalErrorMessage = (
  error: unknown,
): InternalErrorMessage => {
  const messageType = getErrorMessageIfApiError(error as APIError);

  return { type: messageType || 'GENERIC_ERROR' };
};

export const getErrorMessageDescription = (
  errorMessage: InternalErrorMessage,
): string => ERROR_MESSAGES_MAP[errorMessage.type];
